import firebase from 'firebase';
const FIRE_CONFIG = {
    apiKey: "AIzaSyBwpJIpeoP8gU1YBM4waMxVP-fEjvRhBc4",
    storageBucket: "honeycomb-ai.appspot.com",
    authDomain: "honeycomb-ai.firebaseapp.com",    
};
firebase.initializeApp(FIRE_CONFIG);

export const PROVIDER_GOOGLE = new firebase.auth.GoogleAuthProvider();
export const PROVIDER_FACEBOOK = new firebase.auth.FacebookAuthProvider();
export const auth = firebase.auth();
export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js